
export const LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS = "[FULL REPORT PRIMARY/SENTIMENT] LOAD_PRIMARY_EMOTIONS_BREAKDOWN_SUCCESS";
export const SEARCH_CHANGE = "[FULL REPORT PRIMARY/SENTIMENT] SEARCH CHANGE";
export const LOAD_SENTIMENT_BREAKDOWN_SUCCESS = "[FULL REPORT PRIMARY/SENTIMENT] LOAD_SENTIMENT_BREAKDOWN_SUCCESS";


// WEBPACK FOOTER //
// ./src/modules/full-report-primary-or-sentiment/full-report-primary-or-sentiment-action-types.js